import type { Value } from '../schema/value';
import { parseBlacklistArray } from './parseBlacklist';
import { parseCustomFieldTexts } from './parseCustomFields';
import {
    boolFromStringFlag,
    imageUrlField,
    intFromMixed,
    localized,
    numericString,
    optionalString,
} from './coerce';

export function parseValueArray(raw: unknown): Value[] {
    if (!Array.isArray(raw)) return [];
    // Sort by sort_order at parse time — mirrors legacy storage.js:1134
    // (`optionTemplate.choices.sort(compareOptions)`). The admin Drag&Drop
    // updates `sort_order` fields but leaves array insertion order intact,
    // so a parser that respects array order would render the values in the
    // wrong sequence after every reorder.
    return raw.map(parseValue).sort((a, b) => a.sortOrder - b.sortOrder);
}

function parseValue(raw: unknown): Value {
    const r = (raw ?? {}) as Record<string, unknown>;
    return {
        id: intFromMixed(r.id, 0),
        customFields: parseCustomFieldTexts(r.customFields ?? r.custom_fields),
        title: localized(r.title),
        info: localized(r.info),
        additionalInfo: r.additional_info != null ? localized(r.additional_info) : undefined,
        value: optionalString(r.value),
        price: numericString(r.price),
        sku: optionalString(r.sku),
        sortOrder: intFromMixed(r.sort_order, 0),
        productId: optionalString(r.product_id),
        thumbnail: imageUrlField(r.thumbnail),
        thumbnailAlt: optionalString(r.thumbnail_alt),
        image: imageUrlField(r.image),
        isRequired: boolFromStringFlag(r.is_required),
        combination: boolFromStringFlag(r.combination),
        children: parseValueArray(r.choices),
        blacklist: parseBlacklistArray(r.blacklist),
    };
}
